module.exports = __webpack_public_path__ + "img/Office_Group_Laptop_Foreground_Agent_Insights.6e032eb0.jpg";